var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-attendance-dashboard"},[_c('div',{staticClass:"attendance-content"},[_c('img',{staticClass:"img-responsive",attrs:{"alt":"attendance image","src":require("@/assets/images/attendance.png")}}),_c('span',{staticClass:"sub-content"})])])
}]

export { render, staticRenderFns }